import { render } from "./TransportSettingsSection.vue?vue&type=template&id=55c245c8"
import script from "./TransportSettingsSection.vue?vue&type=script&lang=js"
export * from "./TransportSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__